(function () {
  'use strict';

  document.querySelectorAll('.eb-collection').forEach(initEbCollection);

  function initEbCollection(root) {
    safeRun(function () { initAutoSwatchColors(root); });
    safeRun(function () { initWishlist(root); });
    safeRun(function () { initFilterDrawer(root); });
    safeRun(function () { initColorToggle(root); });

    safeRun(function () { window.setTimeout(function () { initAutoSwatchColors(root); }, 500); });
    if (document.readyState !== 'complete') {
      window.addEventListener('load', function () { safeRun(function () { initAutoSwatchColors(root); }); });
    }
  }

  function safeRun(fn) {
    try {
      fn();
    } catch (err) {
      if (window.console && console.error) console.error('[eb-collection]', err);
    }
  }

  var COLOR_NAME_MAP = {
    'black': '#1a1a1a', 'white': '#ffffff', 'ivory': '#f5f0e6', 'off white': '#f5f0e6', 'off-white': '#f5f0e6',
    'cream': '#f2e8d5', 'beige': '#e3d5c0', 'tan': '#d2b48c', 'khaki': '#c3b091', 'camel': '#c19a6b',
    'taupe': '#8b7d6b', 'olive': '#6b6b3a', 'green': '#3a7d44', 'emerald': '#046307',
    'forest': '#2e4a2e', 'forest green': '#2e4a2e', 'hunter green': '#355e3b',
    'sage': '#9caf88', 'sage green': '#9caf88', 'mint': '#a8d8c9', 'teal': '#367588', 'turquoise': '#40c0c0',
    'navy': '#1b2a4a', 'navy blue': '#1b2a4a', 'blue': '#3a6ea5',
    'sky blue': '#a7c7e7', 'baby blue': '#a7c7e7', 'light blue': '#a7c7e7', 'royal blue': '#3457d5',
    'cobalt': '#1e5fa8', 'cobalt blue': '#1e5fa8', 'indigo': '#3b3a70',
    'periwinkle': '#a3b4e0', 'cornflower': '#a3b4e0', 'cornflower blue': '#a3b4e0',
    'seafoam': '#9fd8c8', 'seafoam green': '#9fd8c8', 'denim': '#4a6a8a', 'jade': '#00a86b',
    'army green': '#5c5a3a', 'olive green': '#5c5a3a', 'lime': '#9fd63b', 'chartreuse': '#9fd63b',
    'neon green': '#39ff14', 'neon yellow': '#eaff00', 'neon orange': '#ff5f1f', 'neon pink': '#ff2fb0',
    'red': '#b02e2e', 'crimson': '#c4212e', 'scarlet': '#c4212e', 'cherry': '#9e1b32',
    'brick': '#b5502d', 'terracotta': '#b5502d', 'terra cotta': '#b5502d',
    'maroon': '#5c1a1a', 'burgundy': '#6d1b2b', 'wine': '#6d1b2b', 'raspberry': '#a02255',
    'pink': '#e8a0b4', 'baby pink': '#f4c2c2', 'blush pink': '#f4c2c2', 'blush': '#e0a8a0', 'rose': '#e0a8a0',
    'dusty rose': '#c9959a', 'mauve': '#c9959a', 'hot pink': '#e0218a', 'fuchsia': '#e0218a', 'fuschia': '#e0218a', 'magenta': '#c2185b',
    'purple': '#6a4c93', 'lavender': '#c6b8e0', 'lilac': '#d7bde2', 'orchid': '#d7bde2',
    'violet': '#7b4fa0', 'amethyst': '#7b4fa0', 'plum': '#5b3256', 'eggplant': '#5b3256',
    'orange': '#d9752b', 'rust': '#a4502a', 'coral': '#e8836b', 'salmon': '#e58f7f',
    'peach': '#f4b896', 'apricot': '#f4b896', 'yellow': '#e0c341', 'mustard': '#c9a13b',
    'marigold': '#f3c13a', 'canary': '#f3c13a', 'canary yellow': '#f3c13a', 'gold': '#c9a646',
    'champagne': '#e8d7ae', 'bronze': '#8c6239', 'copper': '#b3651f',
    'brown': '#6b4a34', 'chocolate': '#4a2e1f', 'coffee': '#4b3621', 'espresso': '#4b3621',
    'mocha': '#8a6952', 'latte': '#8a6952', 'chestnut': '#5a3825', 'mahogany': '#5a3825', 'walnut': '#5a3825',
    'caramel': '#b6803a', 'honey': '#b6803a', 'butterscotch': '#b6803a',
    'sand': '#d9c7a3', 'sand dune': '#d9c7a3', 'wheat': '#d9c7a3', 'oatmeal': '#d9c7a3',
    'stone': '#b6a892', 'clay': '#b6a892', 'grey': '#8a8a8a', 'gray': '#8a8a8a',
    'light grey': '#c4c4c4', 'light gray': '#c4c4c4', 'slate': '#5b6b73', 'slate grey': '#5b6b73', 'slate gray': '#5b6b73',
    'charcoal': '#3a3a3a', 'gunmetal': '#3b3f42', 'graphite': '#3b3f42',
    'jet black': '#0b0b0b', 'onyx': '#0b0b0b', 'silver': '#c0c0c0', 'platinum': '#c0c0c0',
    'pearl': '#f7f5f0', 'bone': '#f7f5f0', 'snow': '#f7f5f0', 'snow white': '#f7f5f0',
    'multi': 'linear-gradient(135deg,#e8a0b4,#a7c7e7,#e0c341)',
    'multicolor': 'linear-gradient(135deg,#e8a0b4,#a7c7e7,#e0c341)',
    'multi-color': 'linear-gradient(135deg,#e8a0b4,#a7c7e7,#e0c341)',
    'print': 'linear-gradient(135deg,#e8a0b4,#a7c7e7,#e0c341)'
  };

  var COLOR_CONTAINS_ORDER = [
    'off white', 'off-white', 'ivory', 'cream', 'beige', 'khaki', 'camel', 'taupe',
    'sage', 'mint', 'forest', 'hunter', 'olive', 'emerald', 'lime', 'chartreuse',
    'seafoam', 'jade', 'teal', 'turquoise', 'green',
    'navy', 'baby blue', 'sky', 'royal', 'cobalt', 'periwinkle', 'cornflower', 'denim', 'indigo', 'blue',
    'crimson', 'scarlet', 'cherry', 'brick', 'terracotta', 'terra cotta', 'maroon', 'burgundy', 'wine',
    'raspberry', 'red',
    'blush', 'dusty rose', 'mauve', 'rose', 'hot pink', 'fuchsia', 'fuschia', 'magenta', 'pink',
    'lavender', 'lilac', 'orchid', 'violet', 'amethyst', 'plum', 'eggplant', 'purple',
    'rust', 'coral', 'salmon', 'peach', 'apricot', 'orange',
    'mustard', 'marigold', 'canary', 'champagne', 'gold', 'yellow',
    'bronze', 'copper', 'chocolate', 'coffee', 'espresso', 'mocha', 'latte',
    'chestnut', 'mahogany', 'walnut', 'caramel', 'honey', 'butterscotch', 'brown',
    'sand', 'wheat', 'oatmeal', 'stone', 'clay', 'slate', 'charcoal', 'gunmetal', 'graphite',
    'jet black', 'onyx', 'black',
    'silver', 'platinum', 'pearl', 'bone', 'snow', 'grey', 'gray', 'white',
    'multi', 'print'
  ];

  function findFuzzyColor(value) {
    for (var i = 0; i < COLOR_CONTAINS_ORDER.length; i++) {
      var key = COLOR_CONTAINS_ORDER[i];
      if (value.indexOf(key) !== -1 && COLOR_NAME_MAP[key]) {
        return COLOR_NAME_MAP[key];
      }
    }
    return null;
  }

  function resolveOneColor(word) {
    word = (word || '').trim();
    if (!word) return null;
    return COLOR_NAME_MAP[word] || findFuzzyColor(word);
  }

  function splitDualColor(value) {
    var parts = value.split(/\s*\/\s*|\s+(?:&|and)\s+/i).filter(function (p) { return p; });
    return parts.length === 2 ? parts : null;
  }

  function colorFor(value) {
    var hex = COLOR_NAME_MAP[value];
    if (!hex) {
      var dualParts = splitDualColor(value);
      if (dualParts) {
        var colorA = resolveOneColor(dualParts[0]);
        var colorB = resolveOneColor(dualParts[1]);
        if (colorA && colorB) {
          hex = 'linear-gradient(135deg, ' + colorA + ' 50%, ' + colorB + ' 50%)';
        } else {
          hex = colorA || colorB;
        }
      }
    }
    if (!hex) hex = findFuzzyColor(value);
    return hex;
  }

  function initAutoSwatchColors(root) {
    root.querySelectorAll('.eb-collection__color-filter-swatch--auto, .eb-collection__card-swatch--auto').forEach(function (swatch) {
      try {
        var value = (swatch.getAttribute('data-value') || '').trim().toLowerCase();
        var hex = colorFor(value);
        if (hex) swatch.style.setProperty('--swatch-color', hex);
      } catch (err) {
        if (window.console && console.error) console.error('[eb-collection] swatch color failed for', swatch, err);
      }
    });
  }

  function initWishlist(root) {
    root.querySelectorAll('[data-wishlist-button]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        var pressed = btn.getAttribute('aria-pressed') === 'true';
        btn.setAttribute('aria-pressed', pressed ? 'false' : 'true');
        btn.classList.toggle('is-active', !pressed);
      });
    });
  }

  function initColorToggle(root) {
    root.querySelectorAll('.eb-collection__filter-options--swatch').forEach(function (group) {
      try {
        if (group.getAttribute('data-toggle-ready')) return;
        if (group.getClientRects().length === 0) return;
        group.setAttribute('data-toggle-ready', 'true');

        var items = Array.prototype.slice.call(group.children);
        items.forEach(function (el, i) { el._ebIndex = i; });
        items.sort(function (a, b) {
          var aActive = a.classList.contains('is-active') ? 1 : 0;
          var bActive = b.classList.contains('is-active') ? 1 : 0;
          if (aActive !== bActive) return bActive - aActive;
          var aCount = parseInt(a.getAttribute('data-count'), 10) || 0;
          var bCount = parseInt(b.getAttribute('data-count'), 10) || 0;
          if (aCount !== bCount) return bCount - aCount;
          return a._ebIndex - b._ebIndex;
        });
        items.forEach(function (el) { group.appendChild(el); });

        group.classList.add('is-collapsed');
        if (group.scrollHeight <= group.clientHeight + 2) {
          group.classList.remove('is-collapsed');
          return;
        }

        var moreLabel = group.getAttribute('data-more-label') || 'More colors';
        var lessLabel = group.getAttribute('data-less-label') || 'Fewer colors';
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'eb-collection__swatch-toggle';
        btn.textContent = moreLabel;
        btn.setAttribute('aria-expanded', 'false');
        btn.addEventListener('click', function () {
          var collapsed = group.classList.toggle('is-collapsed');
          btn.textContent = collapsed ? moreLabel : lessLabel;
          btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        });
        group.parentNode.insertBefore(btn, group.nextSibling);
      } catch (err) {
        if (window.console && console.error) console.error('[eb-collection] color toggle failed', err);
        group.classList.remove('is-collapsed');
      }
    });
  }

  function initFilterDrawer(root) {
    var toggle = root.querySelector('[data-eb-filter-toggle]');
    var sidebar = root.querySelector('[data-eb-filter-sidebar]');
    if (!toggle || !sidebar) return;
    var closeBtn = sidebar.querySelector('[data-eb-filter-close]');
    toggle.addEventListener('click', function () {
      sidebar.classList.toggle('is-open');
      safeRun(function () { initColorToggle(root); });
    });
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        sidebar.classList.remove('is-open');
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') sidebar.classList.remove('is-open');
    });
  }
})();